import React, { useState, useEffect } from 'react';
import axios from 'axios';

const SocialMediaManager = () => {
  const [items, setItems] = useState([]);
  const [showForm, setShowForm] = useState(false);
  const [editingItem, setEditingItem] = useState(null);
  const [formData, setFormData] = useState({
    platform: '',
    url: '',
    icon: '',
    order_index: 0,
    is_active: true
  });
  const [loading, setLoading] = useState(false);

  const platformOptions = [
    'Facebook',
    'Twitter',
    'Instagram',
    'YouTube',
    'Telegram',
    'Discord',
    'WhatsApp',
    'LinkedIn',
    'TikTok',
    'Kick'
  ];

  useEffect(() => {
    fetchItems();
  }, []);

  const fetchItems = async () => {
    try {
      const token = localStorage.getItem('adminToken');
      const response = await axios.get('/api/social-media', {
        headers: { Authorization: `Bearer ${token}` }
      });
      setItems(response.data);
    } catch (error) {
      console.error('Error fetching items:', error);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const token = localStorage.getItem('adminToken');

      if (editingItem) {
        await axios.put(`/api/social-media/${editingItem.id}`, formData, {
          headers: { Authorization: `Bearer ${token}` }
        });
      } else {
        await axios.post('/api/social-media', formData, {
          headers: { Authorization: `Bearer ${token}` }
        });
      }

      fetchItems();
      resetForm();
    } catch (error) {
      console.error('Error saving item:', error);
      alert('Kaydetme hatası: ' + (error.response?.data?.error || error.message));
    } finally {
      setLoading(false);
    }
  };

  const handleDelete = async (id) => {
    if (!window.confirm('Bu sosyal medyayı silmek istediğinizden emin misiniz?')) {
      return;
    }

    try {
      const token = localStorage.getItem('adminToken');
      await axios.delete(`/api/social-media/${id}`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      fetchItems();
    } catch (error) {
      console.error('Error deleting item:', error);
      alert('Silme hatası');
    }
  };

  const handleEdit = (item) => {
    setEditingItem(item);
    setFormData({
      platform: item.platform,
      url: item.url,
      icon: item.icon || '',
      order_index: item.order_index,
      is_active: item.is_active
    });
    setShowForm(true);
  };

  const resetForm = () => {
    setFormData({
      platform: '',
      url: '',
      icon: '',
      order_index: 0,
      is_active: true
    });
    setEditingItem(null);
    setShowForm(false);
  };

  return (
    <div className="bg-gradient-card rounded-xl p-6 border border-gold/30">
      <div className="flex justify-between items-center mb-6">
        <h2 className="text-2xl font-bold text-gold">Sosyal Medya Yönetimi</h2>
        <button
          onClick={() => setShowForm(!showForm)}
          className="bg-gradient-to-r from-gold to-yellow-500 hover:from-yellow-500 hover:to-gold text-navy-900 font-bold px-4 py-2 rounded-lg transition-all duration-300 shadow-gold"
        >
          {showForm ? 'İptal' : '+ Yeni Ekle'}
        </button>
      </div>

      {showForm && (
        <form onSubmit={handleSubmit} className="bg-navy-700 p-6 rounded-lg mb-6 space-y-4">
          <div>
            <label className="block text-white mb-2">Platform *</label>
            <select
              value={formData.platform}
              onChange={(e) => setFormData({ ...formData, platform: e.target.value })}
              className="w-full px-3 py-2 bg-navy-600 border border-gold/30 rounded text-white"
              required
            >
              <option value="">Seçiniz</option>
              {platformOptions.map(platform => (
                <option key={platform} value={platform}>{platform}</option>
              ))}
            </select>
          </div>

          <div>
            <label className="block text-white mb-2">URL *</label>
            <input
              type="url"
              value={formData.url}
              onChange={(e) => setFormData({ ...formData, url: e.target.value })}
              className="w-full px-3 py-2 bg-navy-600 border border-gold/30 rounded text-white"
              placeholder="https://facebook.com/yourpage"
              required
            />
          </div>

          <div>
            <label className="block text-white mb-2">Sıra</label>
            <input
              type="number"
              value={formData.order_index}
              onChange={(e) => setFormData({ ...formData, order_index: parseInt(e.target.value) })}
              className="w-full px-3 py-2 bg-navy-600 border border-gold/30 rounded text-white"
            />
          </div>

          <div className="flex items-center gap-2">
            <input
              type="checkbox"
              checked={formData.is_active}
              onChange={(e) => setFormData({ ...formData, is_active: e.target.checked })}
              className="w-4 h-4"
            />
            <label className="text-white">Aktif</label>
          </div>

          <button
            type="submit"
            disabled={loading}
            className="w-full bg-gradient-to-r from-gold to-yellow-500 hover:from-yellow-500 hover:to-gold text-navy-900 font-bold py-2 px-4 rounded-lg transition-all duration-300 shadow-gold disabled:opacity-50"
          >
            {loading ? 'Kaydediliyor...' : (editingItem ? 'Güncelle' : 'Ekle')}
          </button>
        </form>
      )}

      <div className="space-y-4">
        {items.map((item) => (
          <div key={item.id} className="bg-navy-700 p-4 rounded-lg flex items-center justify-between">
            <div className="flex-1">
              <h3 className="text-white font-bold">{item.platform}</h3>
              <p className="text-white/60 text-sm break-all">{item.url}</p>
              <p className="text-white/60 text-sm">Sıra: {item.order_index} | Durum: {item.is_active ? 'Aktif' : 'Pasif'}</p>
            </div>
            <div className="flex gap-2">
              <button
                onClick={() => handleEdit(item)}
                className="bg-blue-500 hover:bg-blue-600 text-white px-3 py-1 rounded"
              >
                Düzenle
              </button>
              <button
                onClick={() => handleDelete(item.id)}
                className="bg-red-500 hover:bg-red-600 text-white px-3 py-1 rounded"
              >
                Sil
              </button>
            </div>
          </div>
        ))}

        {items.length === 0 && (
          <p className="text-center text-white/60 py-8">Henüz sosyal medya eklenmedi</p>
        )}
      </div>
    </div>
  );
};

export default SocialMediaManager;
